module.exports = __webpack_public_path__ + "img/border-verticle.4d27cb86.svg";